import React from 'react';
import { Edit, Trash2 } from 'lucide-react';
import { IconButton } from '@atoms';

export interface UserActionButtonsProps {
  /** Callback for edit action */
  onEdit: () => void;
  /** Callback for delete action */
  onDelete: () => void;
  /** Whether delete action is loading */
  isDeleting?: boolean;
  /** Additional CSS classes */
  className?: string;
}

/**
 * UserActionButtons Molecule Component
 * 
 * Action buttons for user table rows (edit, delete).
 * 
 * @example
 * ```tsx
 * <UserActionButtons
 *   onEdit={() => handleEdit(user)}
 *   onDelete={() => handleDelete(user)}
 *   isDeleting={deleteLoading}
 * />
 * ```
 */
export const UserActionButtons: React.FC<UserActionButtonsProps> = ({
  onEdit,
  onDelete,
  isDeleting = false,
  className = '',
}) => {
  return (
    <div className={`flex items-center justify-end space-x-2 ${className}`}>
      {/* <IconButton
        icon={Shield}
        variant="secondary"
        title="Manage Roles"
        onClick={onManageRoles}
      /> */}
      <IconButton
        icon={Edit}
        variant="primary"
        title="Edit User"
        onClick={onEdit}
      />
      <IconButton
        icon={Trash2}
        variant="error"
        title="Delete User"
        onClick={onDelete}
        loading={isDeleting}
        disabled={isDeleting}
      />
    </div>
  );
};
